export default "__VITE_ASSET__CbcFcsMx__"